module.exports = __webpack_public_path__ + "img/delivery-details-empty-state.3535ef6b.svg";